//----------------------------------------------------
//  iSMe-OzEl CANVAS SCRIPT
//  iPhone 17 Pro / 17 Pro Max için kamera adası kırpma (preview mask)
//  + Runway + Allura özel hizalama
//  + direction=2 ve direction=3 için ayrı maske
//----------------------------------------------------

var canvas = document.getElementById("ismeOzelCaseCanvas");
var ctx = canvas.getContext("2d");

var text = "";
var color = "white";
var font = "Glitter";
var fontSize = 50;

// 0 = yatay ortada, 1 = yatay altta, 2 = dikey sağa yaslı, 3 = dikey ortada
var direction = 0;

// ----------------- STRING / DEVICE HELPERS -------------------

function normalizeModelStr(s) {
  if (!s) return "";
  return String(s)
    .toLowerCase()
    .replace(/ı/g, "i")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

/**
 * Sadece iPhone 17 Pro ve iPhone 17 Pro Max
 * (Template içinde: window.deviceModel = {{ product.title | json }}; )
 */
function isIphone17ProOrProMax() {
  var m = normalizeModelStr(window.deviceModel);
  if (m.includes("iphone 17 pro max")) return true;
  if (m.includes("iphone 17 pro")) return true;
  return false;
}

// ----------------- UI HELPERS -----------------------

function selectedBox(cDiv) {
  var container = cDiv.parentElement;
  var selectedBoxes = container.querySelectorAll(".selected-box");

  for (var i = 0; i < selectedBoxes.length; i++) {
    selectedBoxes[i].classList.remove("border2px");
  }
  cDiv.classList.add("border2px");
}

function showColor(newColor, cDiv) {
  selectedBox(cDiv);
  color = newColor;
  updateText();
}

function setDirection(newDirection, cDiv) {
  selectedBox(cDiv);
  direction = newDirection;
  updateText();
}

function setFont(fontName, cDiv) {
  selectedBox(cDiv);

  font = fontName;
  console.log("Selected Font: ", font);

  document.fonts.load('16px "' + font + '"').then(function () {
    updateText();
  });
}

function validateInput(validateText) {
  return validateText.replace(/[^a-zA-Z0-9 çğıİöşüÇĞİÖŞÜ]/g, "");
}

// ----------------- MASK HELPERS (KIRPMA) -----------------------

function roundedRectPath(ctx, x, y, w, h, r) {
  var radius = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + w - radius, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
  ctx.lineTo(x + w, y + h - radius);
  ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
  ctx.lineTo(x + radius, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
}

/**
 * iPhone 17 Pro/Pro Max kamera adası preview kırpma maskesi
 * direction=2 ve direction=3 için ayrı maske
 * 400x400 canvas için yaklaşık değerler.
 */
function applyIphone17CameraCropMask() {
  if (!isIphone17ProOrProMax()) return;

  // sadece dikey modlarda anlamlı (isteğe göre yatayda da çalıştırabilirsin)
  if (!(direction === 2 || direction === 3)) return;

  // direction=3 (dikey ortalı) için mask
  var CAMERA_MASK_CENTER = {
    x: 35,
    y: 10,
    w: 225,
    h: 108,
    r: 36
  };

  // direction=2 (dikey sağa yaslı) için mask (biraz daha sağa/ geniş)
  // Eğer sende hala “dokunmuyor” gibi kalırsa: x’i 10-20 arttır, w’yi 10-20 arttır.
  var CAMERA_MASK_RIGHT = {
    x: 55,
    y: 10,
    w: 245,
    h: 108,
    r: 36
  };

  var M = (direction === 2) ? CAMERA_MASK_RIGHT : CAMERA_MASK_CENTER;

  ctx.save();
  ctx.globalCompositeOperation = "destination-out";
  roundedRectPath(ctx, M.x, M.y, M.w, M.h, M.r);
  ctx.fill();
  ctx.restore();
}

// ----------------- ANA ÇİZİM FONKSİYONU ------------

function updateText() {
  var ozelIsimInput = document.getElementById("ozelIsim");

  text = validateInput(ozelIsimInput.value);
  ozelIsimInput.value = text;

  localStorage.setItem("ozelIsimText", text);

  // boşsa temizle ve çık
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  if (!text) return;

  fontSize = 400;

  var drawText = text;
  if (font === "Glitter" && drawText !== "") {
    drawText = "[" + drawText + "]";
  }

  ctx.fillStyle = color;

  // 1) Font büyüklüğü limitleri
  var fontSizeLimit;

  if (direction === 2 || direction === 3) {
    // Dikey
    fontSizeLimit = 200;
    if (font === "Glitter") fontSizeLimit = 370;
  } else {
    // Yatay
    fontSizeLimit = 120;
    if (font === "Glitter") fontSizeLimit = 200;
  }

  var textM, textWidth, textHeight;

  do {
    ctx.font = fontSize + "px " + font;
    textM = ctx.measureText(drawText);
    textWidth = textM.width;
    textHeight = textM.actualBoundingBoxDescent;
    fontSize--;
  } while (textWidth > fontSizeLimit && fontSize > 1);

  // 2) 17 Pro/Pro Max + (Runway || Allura) + kısa isimlerde özel scale & hizalama
  var extraX = 0;
  var extraY = 0;

  var is17ProFamily = isIphone17ProOrProMax();
  var isSpecialFont = font === "Runway" || font === "Allura";
  var isShortSpecial = isSpecialFont && drawText && drawText.length <= 5;

  if (is17ProFamily && isShortSpecial) {
    var scale = (direction === 2 || direction === 3) ? 0.55 : 0.65;

    fontSize = Math.round(fontSize * scale);

    ctx.font = fontSize + "px " + font;
    textM = ctx.measureText(drawText);
    textWidth = textM.width;
    textHeight = textM.actualBoundingBoxDescent;

    if (direction === 2 || direction === 3) {
      extraY = 30;
    }
  }

  // 3) Pozisyon
  ctx.save();

  var x, y, angle;

  switch (direction) {
    case 0: // yatay ortada
      x = 200 - textWidth / 2 + extraX;
      y = 200 - textHeight / 2 + extraY;
      break;

    case 1: // yatay altta
      x = 200 - textWidth / 2 + extraX;
      y = (400 - 50) - textHeight + extraY;
      break;

    case 2: // dikey sağa yaslı
      x = 270 - textHeight + extraX;
      y = 200 - textWidth / 2 + extraY;
      angle = (270 * Math.PI) / 180;
      break;

    case 3: // dikey ortada
      x = (220 + textHeight) - textHeight / 2 + extraX;
      y = 200 - textWidth / 2 + extraY;
      angle = (270 * Math.PI) / 180;
      break;
  }

  ctx.translate(x, y);

  if (direction === 2 || direction === 3) {
    ctx.rotate(angle);
    ctx.textAlign = "right";
  }

  ctx.fillText(drawText, 0, 0);
  ctx.restore();

  // 4) iPhone 17 Pro/Pro Max: kamera adası kırpma
  applyIphone17CameraCropMask();
}

// ----------------- SUBMIT ÖNCESİ --------------------

function beforeSubmit(event) {
  event.preventDefault();

  $("#loading-overlay").show();

  var canvasEl = document.getElementById("ismeOzelCaseCanvas");
  var casePattern = document.getElementById("ismeOzelImage").src;

  var jsonData = JSON.stringify({
    text: text,
    color: color,
    font: font,
    fontSize: fontSize,
    direction: direction
  });

  var imageData = canvasEl.toDataURL("image/png");

  $.ajax({
    url: "https://mrpshopify.deercase.com/API/newmrpapi2.php",
    type: "POST",
    data: {
      islemId: 3,
      isimData: imageData,
      isimPattern: casePattern
    },
    success: function (data, status) {
      if (data.status == "success") {
        var form = document.querySelector(".form");
        $('input[name="properties[_IsmeOzelCase]"]').val(data.thumbIsimFileName);
        $('input[name="properties[_CustomImageData]"]').val(jsonData);
        form.submit();
      } else {
        $("#loading-overlay").hide();
      }
    },
    error: function (xhr, status, error) {
      console.error("Ajax işlemi başarısız: " + error);
      $("#loading-overlay").hide();
    }
  });
}

// ----------------- FONT LOAD ------------------------

function onFontsLoaded() {
  var ozelIsimEl = document.getElementById("ozelIsim");

  if (localStorage.getItem("ozelIsimText") !== null) {
    ozelIsimEl.value = localStorage.getItem("ozelIsimText");
  }
  updateText();
}

function loadFonts() {
  var glitterFont = new FontFace(
    "Glitter",
    "url(//deercase.com/cdn/shop/t/24/assets/glitter.woff2?v=15567647853412780341722207102) format('woff2')"
  );
  var robotoMonoFont = new FontFace(
    "Roboto Mono",
    "url(//deercase.com/cdn/shop/t/24/assets/roboto-mono.woff2?v=34288213666487499971722207102) format('woff2')"
  );
  var runwayFont = new FontFace(
    "Runway",
    "url(//deercase.com/cdn/shop/t/24/assets/runway.woff2?v=113444598748256330591722207102) format('woff2')"
  );
  var alluraFont = new FontFace(
    "Allura",
    "url(//www.deercase.com/cdn/shop/t/25/assets/Allura-Regular.woff2?v=82389757178447923881735654783) format('woff2')"
  );

  Promise.all([
    glitterFont.load(),
    robotoMonoFont.load(),
    runwayFont.load(),
    alluraFont.load()
  ]).then(function () {
    document.fonts.add(glitterFont);
    document.fonts.add(robotoMonoFont);
    document.fonts.add(runwayFont);
    document.fonts.add(alluraFont);
    onFontsLoaded();
  });
}

loadFonts();

// ----------------- LOADING OVERLAY ------------------

window.onload = function () {
  $("#loading-overlay").hide();
};
